import {Button} from 'devextreme-react/button'
import DataGrid, {
    Button as GridButton,
    Column,
    Editing, FilterRow, HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    Sorting,
    Toolbar,
} from 'devextreme-react/data-grid'
import LoadPanel from 'devextreme-react/load-panel'
import React, {useEffect, useState, useRef} from "react"
import {getPoints} from "../../services/point.service"
import {getReads, sendIntegralAkt, sendIntegralReads, sendIntervalAkt} from "../../api/point"
import notify from "devextreme/ui/notify"
import {getTemplateIntegral, getTemplateInterval} from "../../api/template"
import PopupIntegral from "../../components/reads-popup-integral/reads-popup-integral"
import {getCurrentPeriod, getPointsTreePlain} from "../../api/dogovor"
import {useAuth} from "../../contexts/auth"
import PopupInterval from "../../components/reads-popup-interval/reads-popup-interval"
import {Popover} from 'devextreme-react/popover'
import {verifyAccess} from "../../utils/admin.utils"
import AccessDenied from "../../components/access-denied/access-denied"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelopeOpenText, faShareFromSquare} from "@fortawesome/free-solid-svg-icons";
import { parseNumber } from "devextreme/localization"
import PopupPointsTreeHook from "../../components/points-tree/popup-point-tree-hook"
import {Buffer} from 'buffer';
import NumberEditor from "../../components/number-editor/number-editor";
import TreeHook from "../../components/points-tree/tree-hook";
import {useScreenSize} from "../../utils/media-query";
import {Item} from "devextreme-react/toolbar";
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import ScrollView from "devextreme-react/scroll-view";
import {Popup} from "devextreme-react/popup";
import {TextBox} from "devextreme-react";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import ErrorPopup from "../../components/error-popup/error-popup";
import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import {
    fetchReadsSubmitPeriod,
    getReadsSubmitPeriodMessage,
    isDayInReadsSubmitPeriod,
} from "../../utils/reads-submit-period";


const numberEditorRender = ({value, setValue}) => (
    <NumberEditor value={value} setValue={setValue}/>
)

const NumberRangeEditor = ({value, setValue}) => {
    const handleInput = (e) => {
        let input = e.event.target.value;

        // Убираем всё, кроме цифр
        input = input.replace(/[^0-9]/g, '');

        // Преобразуем в число
        let numericValue = parseInt(input, 10);

        // Ограничиваем диапазон
        if (numericValue < 0 || isNaN(numericValue)) {
            numericValue = 0;
        } else if (numericValue > 100) {
            numericValue = 100;
        }

        // Обновляем поле ввода
        e.event.target.value = numericValue.toString();

        // Передаём значение в DataGrid
        setValue(numericValue);
    };

    return (
        <TextBox
            defaultValue={value != null ? value.toString() : ''}
            onInput={handleInput}
            inputAttr={{style: 'text-align: right;'}}
        />
    );
};

const numberRangeEditorRender = ({value, setValue}) => (
    <NumberRangeEditor value={value} setValue={setValue}/>
)

const PokazaniaEditPage = () => {
    const isKazan = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt'
    const envRenegy = process.env.REACT_APP_NAME_ENV === 'renergy'
    let { isLarge } = useScreenSize();
    const [visibleGrid, setVisibleGrid] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [selectedPoints, setSelectedPoints] = useState([])
    const [loadExcelVisible, setLoadExcelVisible] = useState(false)
    const [loadIntervalVisible, setLoadIntervalVisible] = useState(false)
    const [uploadMultiple, setUploadMultiple] = useState(false)
    const { selectedDog, updateCountNotReads, impersonate } = useAuth()
    const [currentPeriod, setCurrentPeriod] = useState({})
    const [points, setPoints] = useState(null)
    const [popoverVisible, setPopoverVisible] = useState(false)
    const [visiblePage, setVisiblePage] = useState(true)
    const [loadingVisibleTreeHook, setloadingVisibleTreeHook] = useState(false)
    const dataGridRef = useRef(null);
    const saveButtonRef = useRef(null);
    const cancelButtonRef = useRef(null);
    const [popupVisible, setPopupVisible] = useState(false);

    const [popupErrorVisible, setPopupErrorVisible] = useState(false);
    const [popupErrorText, setPopupErrorText] = useState('');
    const [popupIcon, setPopupIcon] = useState(null);
    const [popupTitle, setPopupTitle] = useState("Ошибка");
    const [popupWidth, setPopupWidth] = useState(500);
    const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null);
    const [onOk, setOnOk] = useState(null);
    const [btnVisibleCancel, setBtnVisibleCancel] = useState(true);
    const [readsSubmitAllowed, setReadsSubmitAllowed] = useState(true);
    const [readsSubmitMessage, setReadsSubmitMessage] = useState('');
    const onCancel= () => {setPopupErrorVisible(false)};

    const onTreeSelect = (mas) => {
        const points = getPoints(mas)
        setSelectedPoints(points)
        setVisibleGrid(points.length > 0)
        if (points.length === 0) setDataSource([])
    }

    useEffect(() => {
        const pageRoles = [2]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function () {
            setVisiblePage(true)
            setLoading(true)
            setPoints(null)
            setDataSource([])
            setSelectedPoints([])
            setloadingVisibleTreeHook(true)
            //получаем точки по договору
            const res = await getPointsTreePlain(selectedDog.kodDog, 'all', 1)
            if (res.isOk) {
                setPoints(res.data)
            } else {
                notify(res.message, 'error', 5000)
            }

            //получаем период по договору
            const periodRes = await getCurrentPeriod(selectedDog.kodDog)
            if (periodRes.isOk) {
                setCurrentPeriod(periodRes.data)
            } else {
                notify(periodRes.message,'error',5000)
            }

            // окно передачи показаний из tc_resource
            const submitPeriod = await fetchReadsSubmitPeriod()
            const inSubmitPeriod = isDayInReadsSubmitPeriod(submitPeriod)
            // Имперсонация: передача разрешена вне окна, но текст ограничения показываем
            setReadsSubmitAllowed(inSubmitPeriod || !!impersonate)
            setReadsSubmitMessage(getReadsSubmitPeriodMessage(submitPeriod, isKazan))
            setLoading(false)
            setloadingVisibleTreeHook(false)
        })()
    }, [selectedDog, impersonate, isKazan])

    const onRefreshClick = async () => {
        setLoading(true)
        if (selectedPoints.length > 0) {
            const reads = await getReads(selectedPoints,currentPeriod.period,currentPeriod.period,'PRIEM')
            if (reads.isOk) {
                const preparedReads = reads.data.map((read, index) => {
                    const row = {
                        ...read,
                        kod_point: read.source_kod_point ?? read.kod_point,
                        kod_point_pu: read.source_kod_point_pu ?? read.kod_point_pu,
                        kod_point_ini: read.source_kod_point_ini ?? read.kod_point_ini,
                        _row_key: `${read.source_kod_point ?? read.kod_point}-${read.source_kod_point_ini ?? read.kod_point_ini}-${read.pus_num_pu ?? read.num_pu}-${index}`,
                    }
                    if (isKazan) {
                        row.accepted_readlast = read.accepted_readlast ?? read.readlast
                        row.readlast = read.user_readlast ?? null
                    }
                    return row
                })
                dataGridRef.current?.instance.cancelEditData()
                setActionButtonsDisabled(true)
                setDataSource(preparedReads)
            }
            else notify(reads.message, 'error', 5000)
        } else setDataSource([])
        setLoading(false)
    }

    /*const onIsue = async () => {
        setLoading(true)
        if (selectedPoints.length > 0) {
            let resToken
            if (+selectedDog.parameter_uk !== 1) {
                resToken = await getToken(dataSource[0]?.num_pu)
            } else {
                resToken = await getTokenUk(fias[0])
            }//'885b2c35-8547-4946-8a7d-20c47df8a0c9'
            if (resToken.isOk) {
                let json = resToken.data
                if (json.hasOwnProperty('token')){
                    window.open(json.url + json.token, '_blank');
                } else {
                    notify('Объект не содержит token', 'error', 3000)
                }
            } else {
                notify(resToken.message, 'error', 3000)
            }
        } else notify('Не выбран объект', 'error', 3000)
        setLoading(false)
    }*/

    const loadExcel = () => {
        if (!readsSubmitAllowed) {
            notify('Передача показаний сейчас недоступна.', 'error', 5000)
            return
        }
        setUploadMultiple(false)
        setLoadExcelVisible(true)

    }

    const loadInterval = () => {
        if (!readsSubmitAllowed) {
            notify('Передача показаний сейчас недоступна.', 'error', 5000)
            return
        }
        setUploadMultiple(false)
        setLoadIntervalVisible(true)
    }

    const onHidingIntegralPopup = () => {
        setLoadExcelVisible(false)
    }

    const onHidingIntervalPopup = () => {
        setLoadIntervalVisible(false)
    }

    const loadTemplateIntegral = async () => {
        setLoading(true)
        console.log(selectedDog.kodDog)
        const res = await getTemplateIntegral(currentPeriod.period,selectedPoints,selectedDog.kodDog)
        if (res.isOk){
            const file = res.data.data
            const filename = res.data.filename
            var fileDownload = require('js-file-download')
            fileDownload(Buffer.from(file), filename)
        } else notify(res.message,'error',5000)
        setLoading(false)
    }

    const loadTemplateInterval = async (interval) => {
        setLoading(true)
        const res = await getTemplateInterval(currentPeriod.period,selectedPoints,interval,selectedDog.kodDog)
        if (res.isOk){
            const file = res.data.data
            const filename = res.data.filename
            var fileDownload = require('js-file-download')
            fileDownload(Buffer.from(file), filename)
        } else notify(res.message,'error',5000)
        setLoading(false)
    }

    const onSendIntegralFile = async (files) => {
        if (!readsSubmitAllowed) {
            notify('Передача показаний сейчас недоступна.', 'error', 5000)
            return
        }
        setLoading(true);

        const fd = new FormData()
        for (let i=0; i<files.length; i++) {
            fd.append('files',files[i])
        }
        fd.append('dogovor', selectedDog.kodDog)
        fd.append('period', currentPeriod.period)
        //console.log(fd)

        const result = await sendIntegralAkt(fd)
        if (result.isOk) {
            setLoadExcelVisible(false)
            notify(result.message, 'success', 5000)
            updateCountNotReads(selectedDog)
        } else {
            notify(result.message, 'error', 10000);
        }

        setLoading(false)
    }

    const onSendIntervalFile = async (files) => {
        if (!readsSubmitAllowed) {
            notify('Передача показаний сейчас недоступна.', 'error', 5000)
            return
        }
        setLoading(true);

        const fd = new FormData()
        for (let i=0; i<files.length; i++) {
            fd.append('files',files[i])
        }
        fd.append('dogovor', selectedDog.kodDog)
        fd.append('period', currentPeriod.period)
        //console.log(fd)

        const result = await sendIntervalAkt(fd)
        if (result.isOk) {
            setLoadIntervalVisible(false)
            notify(result.message, 'success', 5000)
            updateCountNotReads(selectedDog)
        } else {
            notify(result.message, 'error', 10000);
        }

        setLoading(false)
    }

    const pageSizes = [10, 25, 50, 100]

    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    const readingsEqual = (left, right) => {
        const leftEmpty = left === null || left === undefined || left === ''
        const rightEmpty = right === null || right === undefined || right === ''
        if (leftEmpty || rightEmpty) return leftEmpty && rightEmpty

        const leftNumber = Number(String(left).replace(',', '.'))
        const rightNumber = Number(String(right).replace(',', '.'))
        return Number.isFinite(leftNumber) && Number.isFinite(rightNumber) && leftNumber === rightNumber
    }

    const setActionButtonsDisabled = (disabled) => {
        saveButtonRef.current?.option('disabled', disabled || !readsSubmitAllowed)
        cancelButtonRef.current?.option('disabled', disabled)
    }

    // Логика отмены изменений
    const handleCancelClick = () => {
        if (dataGridRef.current) {
            dataGridRef.current.instance.cancelEditData(); // Отменить изменения
            setActionButtonsDisabled(true)
        }
    };

    const saveTest = async () => {
        if (!readsSubmitAllowed) {
            notify('Передача показаний сейчас недоступна.', 'error', 5000)
            return
        }
        const changes = dataGridRef.current?.instance.option("editing.changes") || []
        //const changes = dataGridRef.current.instance.getController('editing').getChanges(); // идентичен варианту сверху
        //const changes = e.changes// старый метод если из грида onSaved(e)
        if (changes.length === 0) {
            notify('Для передачи показаний необходимо ввести хотя бы одно редактируемое значение!','error',10000)
            return
        }
        let reads = [];
        let readsErr = [];
        for (let change of changes) {
            const sourceRow = dataSource.find(row => row._row_key === change.key)
            if (!sourceRow) continue

            const changedRow = {...sourceRow, ...change.data}
            const point = changedRow.kod_point
            const counter = changedRow.readlast
            const num_pu = changedRow.pus_num_pu ?? changedRow.num_pu
            const kod_point_ini = changedRow.kod_point_ini
            const kod_point_pu = changedRow.kod_point_pu
            const outadd = isKazan ? null : changedRow.outadd
            const lastCounter = changedRow.last_counter
            const name = changedRow.name

            if (
                isKazan &&
                (!Object.prototype.hasOwnProperty.call(change.data, 'readlast') ||
                    readingsEqual(counter, sourceRow.readlast))
            ) {
                continue
            }

            if ((counter && !isNumeric(counter)) || (outadd && !isNumeric(outadd))) {
                notify('Показания могут содержать только цифры и знак разделителя "."!','error',5000)
                return
            }

            if (parseFloat(lastCounter) && (counter - parseFloat(lastCounter) < 0)) {
                readsErr.push({
                    point, num_pu, counter, kod_point_ini, kod_point_pu, outadd, name
                })
                continue;
            }
            reads.push({
                point, num_pu, counter, kod_point_ini, kod_point_pu, outadd, name
            })
        }

        if (reads.length === 0 && readsErr.length === 0) {
            notify('Нет измененных показаний для сохранения.','warning',5000)
            dataGridRef.current?.instance.cancelEditData()
            setActionButtonsDisabled(true)
            return
        }

        if (readsErr.length > 0) {
            let errMessage = "Cледующие показания меньше предыдущих!<br/> Ok - сохранить, Отмена - вернуться к редактированию.<br/><ol>"
            readsErr.forEach(e => {
                errMessage += '<li>' + e.name + '</li>'
            })
            errMessage += '<ol/>'
            setPopupErrorText(errMessage)
            setPopupIcon(faTriangleExclamation)
            setPopupTitle('Внимание')
            setPopupClassNameColorIcon('main-color-light')
            setPopupWidth(500)
            setPopupErrorVisible(true)
            setBtnVisibleCancel(true)
            setOnOk(() => async () => {
                saveReadsInDb([...reads, ...readsErr]);
                setPopupErrorVisible(false)
            })
        } else {
            saveReadsInDb(reads);
        }
    }

    const saveReadsInDb = async (reads) => {
        setLoading(true)
        const resData = await sendIntegralReads(currentPeriod.period, reads)
        if (resData.isOk) {
            //setPopoverVisible(true)
            dataGridRef.current.instance.saveEditData();
            setActionButtonsDisabled(true)
            await onRefreshClick()
            //updateCountNotReads(selectedDog); // ← откуда это взялось? чото не понятно.
            notify(resData.message,'success',5000)
            let message = "<p>Показания переданы в биллинговую систему для проведения расчетов.</p>\n" +
                "                    <p>Все показания можно просмотреть на странице <a href=\"#/pokazania-history?tab=1\">История показаний</a>.</p>"
            setPopupErrorText(message)
            setPopupIcon(faEnvelopeOpenText)
            setPopupTitle('Показания переданы')
            setPopupClassNameColorIcon('main-color-light')
            setPopupWidth(500)
            setPopupErrorVisible(true)
            setBtnVisibleCancel(false)
            setOnOk(() => async () => {
                setPopupErrorVisible(false)
            })
        } else {
            notify(resData.message,'error',5000)
        }
        setLoading(false)
    }

    const popoverHiding = () => {
        setPopoverVisible(false)
    }

    const readlastRender = (data) => {
        const editIconStyle = readsSubmitAllowed
            ? {color: 'blue', cursor: 'pointer'}
            : {color: '#9e9e9e', cursor: 'default', opacity: 0.6}
        return (
            <div title={
                (parseFloat(data.data.last_counter) && (data.data.readlast - parseFloat(data.data.last_counter) < 0)) ? `Текущее показание меньше предыдущего!`: null
            }
            >{data.data.readlast} <span
                style={editIconStyle}
                title={readsSubmitAllowed ? 'Редактировать' : 'Передача показаний сейчас недоступна.'}
            >&#9998;</span></div>
        )
    }

    const outaddRender = (data) => {
        const editIconStyle = readsSubmitAllowed
            ? {color: 'blue', cursor: 'pointer'}
            : {color: '#9e9e9e', cursor: 'default', opacity: 0.6}
        return (<div>{data.data.outadd} <span
            style={editIconStyle}
            title={readsSubmitAllowed ? 'Редактировать' : 'Передача показаний сейчас недоступна.'}
        >&#9998;</span></div>)
    }

    function calcRashod(e){
        const readlast = e.readlast
        const lastCounter = e.last_counter
        const rkoeff = e.rkoeff
        if (!rkoeff) return
        const outadd = e.outadd
        const razr = e.razr
        const razr2 = e.razr2
        let res = null
        if (!!readlast) {
            const difference = (parseNumber(readlast.toString().replace('.',',')) - (lastCounter ? parseNumber(lastCounter.toString().replace('.',',')) : 0))
            if (difference >= 0){ //console.log(difference)
                res = difference * (rkoeff ? parseNumber(rkoeff.toString().replace('.',',')) : 1) + (outadd ? parseNumber(outadd.toString().replace('.',',')) : 0)}
            else
                res = (difference + Math.pow(10, razr)) * parseNumber(rkoeff.toString().replace('.',',')) + (outadd ? parseNumber(outadd.toString().replace('.',',')) : 0)
        }
        return res ? res.toFixed(razr2 ? parseInt(razr2) : 6): null
    }

    const hidePop = () => {
        setPopupVisible(false)
    }

    const onContentReady = () => {
        const changes = dataGridRef.current?.instance.option("editing.changes") || []
        setActionButtonsDisabled(changes.length === 0)
    }

    const onGridOptionChanged = (e) => {
        if (e.fullName?.startsWith('editing.changes')) {
            const changes = e.component.option('editing.changes') || []
            setActionButtonsDisabled(changes.length === 0)
        }
    }

    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings big-input pokazania-edit'}>
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faShareFromSquare} />
                <h3><strong><ZagolovokFromMenu/></strong></h3>
                {readsSubmitMessage &&
                    <div
                        className="mt20"
                        style={{color: '#b45309', background: '#fff7ed', padding: '12px 16px', borderRadius: 4, whiteSpace: 'pre-wrap'}}
                        dangerouslySetInnerHTML={{__html: readsSubmitMessage}}>
                    </div>
                }
                <div className={''}>
                    <LoadPanel visible={loading} />
                    <div className="row mt20">
                        {!isLarge ?
                            <div className="col-md-12">
                                <PopupPointsTreeHook
                                    points={points}
                                    onSelect={onTreeSelect}
                                    typePoints={'all'}
                                    selectionMode="multiple"
                                    onShow={onRefreshClick}
                                    showDisabled={selectedPoints.length === 0 || currentPeriod === {}}
                                />
                            </div>
                            :
                            <div className="col-lg-3" id='tree-hook'>
                                <LoadPanel position={{ of: '#tree-hook' }} visible={loadingVisibleTreeHook}/>
                                <TreeHook points={points} onSelect={onTreeSelect}  typePoints={'all'} selectionMode="multiple"/>
                            </div>
                        }
                        <div id='form-container' className={(!isLarge ? "col-md-12" : "col-9") + " mt20lgx tree-hook-left"}>
                            {
                                visibleGrid ?
                                    <>
                                    <DataGrid
                                        id="reads-grid"
                                        ref={dataGridRef}
                                        dataSource={dataSource}
                                        keyExpr="_row_key"
                                        showBorders={true}
                                        //focusedRowEnabled={true}
                                        defaultFocusedRowIndex={0}
                                        columnHidingEnabled={false}
                                        noDataText="Нет данных для отображения"
                                        wordWrapEnabled={true}
                                        //onRowUpdating={(data) => {onSaveReads(data); updateCountNotReads(selectedDog);}}
                                        //onSaved={(data) => {onSaveReads(data);}}
                                        //onRowUpdating = {(data) => {onSaveReads(data)}}
                                        onOptionChanged={onGridOptionChanged}
                                        //repaintChangesOnly={true}
                                        onContentReady = {(e) => onContentReady(e)}
                                        allowColumnReordering={true}
                                        allowColumnResizing={true}
                                        rowAlternationEnabled={true}
                                        columnWidth={'auto'}
                                        width={'100%'}

                                    >
                                    <Toolbar>
                                        <Item location="before" locateInMenu="never">
                                            <div className='text-center'>Период: <br/><b>{currentPeriod ? currentPeriod.periodString : 'Не удалось загрузить период'}</b></div>
                                        </Item>
                                        <Item location={isKazan ? "after" : "before"} widget="dxButton" visible={isLarge} locateInMenu="auto">
                                            <Button disabled={selectedPoints.length===0 || currentPeriod === {}} type='default' text="Показать" icon="refresh" onClick={onRefreshClick} />
                                        </Item>
                                        {/*{['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                                        <Item location="before" widget="dxButton" locateInMenu="auto">
                                                <Button disabled={
                                                (+selectedDog.parameter_uk !== 1) ?
                                                    !dataSource[0]?.num_pu || selectedPoints.length === 0
                                                :
                                                    selectedPoints.length === 0 || currentPeriod === {}
                                                } text="Данные ИСУЭ"
                                                        icon="refresh" onClick={onIsue}/>
                                        </Item>
                                        }*/}
                                        {/* Кнопка Save */}
                                        <Item locateInMenu="never"
                                            location="after"
                                            widget="dxButton"
                                            options={{
                                                icon: 'save',
                                                text: 'Сохранить',
                                                onClick: saveTest,
                                                disabled: !readsSubmitAllowed || !(dataGridRef.current?.instance.option("editing.changes") || []).length,
                                                onInitialized: (e) => {
                                                    saveButtonRef.current = e.component
                                                },
                                            }}
                                        />

                                        {/* Кнопка Cancel */}
                                        <Item locateInMenu="auto"
                                            location="after"
                                            widget="dxButton"
                                            options={{
                                                icon: 'close',
                                                text: 'Отмена',
                                                onClick: handleCancelClick,
                                                disabled: !(dataGridRef.current?.instance.option("editing.changes") || []).length,
                                                onInitialized: (e) => {
                                                    cancelButtonRef.current = e.component
                                                },
                                            }}
                                        />
                                        <Item location={isKazan ? "after" : "before"} widget="dxButton" locateInMenu="auto" >
                                            <Button className='block' text={'Массовая загрузка'} icon={'exportxlsx'}
                                                    disabled={!readsSubmitAllowed} onClick={()=>setPopupVisible(true)}>
                                                {/*<i className="dx-icon dx-icon-exportxlsx"></i>
                                                &nbsp;<span className='d-inline-flex'>Массовая&nbsp;загрузка</span>*/}
                                            </Button>
                                        </Item>
                                    </Toolbar>
                                        <Paging defaultPageSize={12} />
                                        <Scrolling columnRenderingMode="virtual" />
                                        <Sorting mode="multiple" />
                                        <FilterRow
                                            visible={true} />
                                        <HeaderFilter visible={true} />
                                        <Pager
                                            visible={true}
                                            allowedPageSizes={[5, 12, 20, 'all']}
                                            displayMode={'full'}
                                            showPageSizeSelector={true}
                                            showInfo={true}
                                            showNavigationButtons={true} />
                                        <Editing
                                            mode="batch"//batch//cell
                                            allowUpdating={readsSubmitAllowed}
                                            allowAdding={false}
                                            allowDeleting={false}
                                            selectTextOnEditStart={true}
                                        />
                                        <Column dataField="name" caption={envRenegy ? "Место установки ПУ" : "Название ТУ"} dataType="string" width={200} allowEditing={false}/>
                                        <Column dataField="nomer" caption="№ ТУ" dataType="string" visibleIndex={envRenegy ? 50 : undefined}
                                                width={isKazan ? 70 : 100} minWidth={isKazan ? 70 : undefined} allowEditing={false}/>
                                        <Column dataField="pus_num_pu" caption="№ ПУ" dataType="string" allowEditing={false}/>
                                        <Column dataField="en_direct" caption="Вид энергии" dataType="string"
                                                width={isKazan ? 90 : undefined} minWidth={isKazan ? 90 : undefined} allowEditing={false}/>
                                        <Column dataField="interval_name" caption="Интервал" dataType="string" allowEditing={false}/>
                                        {isKazan &&
                                            <Column dataField="rkoeff" caption="Расч. коэфф." width={78} dataType="number" allowEditing={false}/>
                                        }
                                        <Column dataField="last_counter" caption="Предыдущие" dataType="string" allowEditing={false}/>{/**/}
                                        <Column cellRender={readlastRender}
                                            dataField="readlast"
                                            caption="Текущие"
                                            dataType="number"
                                            width={'150px'}
                                            editCellRender={numberEditorRender}
                                        />
                                        {isKazan &&
                                            <Column dataField="user_readlast_at" caption="Дата заведения и сохранения"
                                                    dataType="datetime" format="dd.MM.yyyy HH:mm" allowEditing={false}/>
                                        }
                                        {isKazan &&
                                            <Column dataField="accepted_readlast" caption="Показания, принятые к расчету"
                                                    dataType="number" allowEditing={false}/>
                                        }

                                        {/* <Column dataField="out" caption="Расход" dataType="string" allowEditing={false}/> */}
                                        <Column visible={!isKazan && !envRenegy} dataField="outadd" caption="Доп. расход" dataType="number" cellRender={outaddRender}
                                                editCellRender={numberEditorRender}
                                        />
                                        <Column dataField="out_lkk" caption={envRenegy ? "Расход *" : "Расход"} dataType="string" calculateCellValue={calcRashod} allowEditing={false}/>
                                        <Column visible={!isKazan && !envRenegy} dataField="pot_fix" caption="Потери" dataType="number" allowEditing={false}/>
                                        <Column visible={!isKazan && !envRenegy} dataField="pot_prc" caption="Потери (%)" dataType="number"
                                                editCellRender={numberRangeEditorRender}/>
                                        <Column visible={!envRenegy} type="buttons" caption={'Загрузить показания'}>
                                            <GridButton hint={'Загрузить интегральные показания (по шаблону)'} name="excel" text="" icon="xlsfile" onClick={loadExcel}></GridButton>
                                        </Column>
                                        {envRenegy &&
                                            <Column dataField="rkoeff" caption={envRenegy ? "Коэфф." : "Расч. коэфф."} width={78} dataType="number" allowEditing={false}/>
                                        }
                                        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                                        <Paging defaultPageSize={10} />
                                    </DataGrid>
                                    {envRenegy && <p><br/>* Расход указан с учетом КТТ, но без учета потерь и учета транзитных приборов учета.</p>}
                                    </>
                                    :
                                    <div className='text-center-horizontal-vertical d-none d-md-block'><strong>Для ввода интегральных показаний выберите точки учета и нажмите кнопку «Показать»</strong></div>

                            }
                        </div>
                    </div>
                </div>
                <>
                <PopupIntegral
                    visible={loadExcelVisible}
                    title={'Загрузить файл интегральных показаний'}
                    onHiding={onHidingIntegralPopup}
                    multiple={uploadMultiple}
                    onSendFile={onSendIntegralFile}
                />
                <PopupInterval
                    visible={loadIntervalVisible}
                    title={'Загрузить файл интервальных показаний'}
                    onHiding={onHidingIntervalPopup}
                    multiple={uploadMultiple}
                    onSendFile={onSendIntervalFile}
                />
                <Popup
                    visible={popupVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    onHiding={hidePop}
                    maxWidth={370}
                    maxHeight={'90%'}
                    height={'auto'}
                    titleRender={()=>PopupTitleWithIcon('dx-icon-exportxlsx', "Массовая загрузка",hidePop)}
                >
                    <ScrollView width='100%' height='100%'>
                        <div className="row justify-content-around">
                            <div className="col-sm-12 mt-3">
                                <b>Интегральные показания:</b>
                                <Button className={'block mt-12 mt-3'} id="load-integral-template" text="Скачать интегральный шаблон" icon="import" onClick={loadTemplateIntegral} />
                                <Button className={'block mt-12 mt-3'} id="load-integral" text="Загрузить интегральные показания" icon="export" onClick={loadExcel} />
                            </div>
                            <div className="col-sm-12 mt-4">
                                <div><b>Интервальные показания:</b></div>
                                <div className="text">* Значения необходимо заполнять без учета потерь!</div>
                                <Button className={'block mt-12 mt-3'} id="load-interval-template" text="Скачать шаблон (почасовки)" icon="import" onClick={() => {loadTemplateInterval(1)}} />
                                <Button className={'block mt-12 mt-3'} id="load-interval-template-half" text="Скачать шаблон (получасовки)" icon="import" onClick={() => {loadTemplateInterval(0.5)}} />
                                <Button className={'block mt-12 mt-3'} id="load-interval" text="Загрузить интервальные показания" icon="export" onClick={loadInterval} />
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
                <Popover
                    visible={popoverVisible}
                    target="#reads-grid"
                    position="top"
                    width={400}
                    onHiding={popoverHiding}
                    shading={true}
                    shadingColor="rgba(0, 0, 0, 0.5)"
                    showCloseButton={true}
                >
                    <p>Показания переданы в биллинговую систему для проведения расчетов.</p>
                    <p>Все показания можно просмотреть на странице <a href="#/pokazania-history?tab=1">История показаний</a>.</p>
                </Popover>
                <ErrorPopup text={popupErrorText}
                            icon = {popupIcon}
                            width={popupWidth}
                            title ={popupTitle}
                            btnVisible={true}
                            visible={popupErrorVisible}
                            onOk={onOk}
                            classNameColorIcon={popupClassNameColorIcon}
                            btnVisibleCancel={btnVisibleCancel}
                            onCancel={onCancel}
                />
                </>
            </div>
            : <AccessDenied/>}</>
    )
}

export default PokazaniaEditPage
